import { render, staticRenderFns } from "./seconds-wallet-info.vue?vue&type=template&id=3ff8e63a&"
import script from "./seconds-wallet-info.vue?vue&type=script&lang=js&"
export * from "./seconds-wallet-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports